import React from "react";
import { Row } from "react-bootstrap";
import { NavigationHelper } from "../helpers";
import { NewMessageType } from "./components/NewMessageType";

export const MessagesPage: React.FC = () => {

  const [shape, setShape] = React.useState("");
  const [showMore, setShowMore] = React.useState(false);

  React.useEffect(() => { setTimeout(NavigationHelper.showMobileSidebar, 10) }, []) // eslint-disable-line

  const getContents = () => {
    if (shape) return <NewMessageType shape={shape} />
    else return getChooseLayout();
  }

  const getMore = () => {
    if (showMore) {
      return (<>
        <hr />
        <p>Specialty screen layouts</p>
        <ul>
          <li><a href="about:blank" onClick={(e) => { e.preventDefault(); setShape("4:1"); }}>4:1 (For Three Zone Template)</a></li>
        </ul>
      </>)
    }
    else return (<a href="aboutBlank" onClick={(e) => { e.preventDefault(); setShowMore(true); }} style={{ color: "#777" }}>More &raquo;</a>);
  }

  const getChooseLayout = () => {
    return (<>
      <p>Select your screen layout</p>
      <Row>
        <div className="col-sm-3 offset-sm-3 text-center" style={{ paddingBottom: 10 }}>
          <a href="about:blank" onClick={(e) => { e.preventDefault(); setShape("16:9"); }}>
            <img src="/images/screenH.png" className="img-fluid" alt="thumbnail" />
          </a>
        </div>

        <div className="col-sm-2 text-center">
          <a href="about:blank" onClick={(e) => { e.preventDefault(); setShape("9:16"); }}>
            <img src="/images/screenV.png" className="img-fluid" alt="thumbnail" />
          </a>
        </div>
      </Row>
      {getMore()}

    </>);
  }

  return (
    <>
      <h1><i className="fas fa-list-ul"></i> New Message</h1>
      {getContents()}
    </>
  );
};